const ProfileLayout = () => {

    return (
        <h1>From Profile Component</h1>
    )

}

export default ProfileLayout;